/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-nested-ternary */
import { Autocomplete, CircularProgress, Grid, Stack } from "@mui/material";
import {
  fetchReportDetail,
  acceptReport,
  draftReport,
  submitReport,
  fetchUserReportsTo,
} from "apis/coachup";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import { COACHUP_QUESTION_TYPES, PERMISSIONS_NAME } from "lib/constants";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { enqueueSnackbar } from "notistack";
import { displayDate } from "utils/Date";
import { checkPermission } from "utils/HelperFunctions";
import DashboardLayout from "utils/LayoutContainers/DashboardLayout";
import Loader from "utils/Loader";
import DashboardNavbar from "utils/Navbars/DashboardNavbar";
import { isBoolean } from "lodash";
import DynamicForm from "./Common/DynamicForm";
import ReportsListing from "./Common/ReportsListing";
// import ReviewQuestions from "./Common/ReviewQuestions";
import ReviewReport from "./Common/ReviewReport";
import SelfAssessmentGraph from "./Common/SelfAssessmentGraph";
import UserCard from "./Common/UserCard";

function ViewReport() {
  const loginUser = useSelector((state) => state.loginUser.loginUserState);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const { id } = useParams();
  const [selectedReport, setSelectedReport] = useState({});
  const [selectedReportId, setSelectedReportId] = useState();
  const reviewPage = pathname.includes("reports/user");
  const [user, setUser] = useState();
  const [questions, setQuestions] = useState([]);
  const [previousQuestions, setPreviousQuestions] = useState([]);
  const [showPreviousAnswers, setShowPreviousAnswers] = useState(false);
  const [graphData, setGraphData] = useState({
    labels: [],
    datasets: [
      {
        label: "Score",
        color: "primary",
        data: [],
      },
    ],
    average: "0.00",
  });

  const [reportsList, setReportsList] = useState([]);
  const [users, setUsers] = useState([]);
  const [usersLoading, setUsersLoading] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(reviewPage && parseInt(id, 10));
  const [isLoading, setIsLoading] = useState(false);
  const getKey = (type) => {
    switch (type) {
      case COACHUP_QUESTION_TYPES.TEXT:
        return "answerText";
      case COACHUP_QUESTION_TYPES.PIPELINE_HEALTH:
      case COACHUP_QUESTION_TYPES.NUMBER:
      case COACHUP_QUESTION_TYPES.CURRENCY:
      case COACHUP_QUESTION_TYPES.ASSESSMENT:
        return "answerValue";
      case COACHUP_QUESTION_TYPES.BOOLEAN:
        return "answerBool";
      default:
        return "answerText";
    }
  };

  const prefillAnswers = (question, lastGeneratedReport, isChild = false) => {
    if (!question) return null;
    const { CoachupReportQuestions: lastSubmitttedQ } = lastGeneratedReport;
    let foundQ;
    if (isChild) {
      foundQ = lastSubmitttedQ.find(
        (lq) =>
          lq?.childQuestion &&
          lq?.childQuestion?.question === question.question &&
          lq?.childQuestion?.answerType === question?.answerType
      );
      return foundQ?.childQuestion?.CoachupUserAnswer?.[getKey(foundQ?.answerType)];
    }
    foundQ = lastSubmitttedQ.find(
      (lq) => lq?.question === question?.question && lq?.answerType === question?.answerType
    );

    return foundQ?.CoachupUserAnswer?.[getKey(foundQ?.answerType)];
  };

  const getReportsData = async (newReportId) => {
    const newParams = new URLSearchParams(window.location.search);

    const userId = newParams?.get("userId") || [];
    const reportId = newParams?.get("reportId") || [];

    let payload = {
      userId,
      reportId,
    };

    if (reviewPage) {
      payload = {
        userId: parseInt(id, 10),
        reportId: newReportId,
      };
    }

    try {
      setIsLoading(true);
      const { data: res, response } = await fetchReportDetail({
        ...payload,
        reportStatuses:
          parseInt(payload?.userId, 10) === loginUser?.id
            ? ["Open", "Close", "Ready For Review", "Draft"]
            : checkPermission(PERMISSIONS_NAME?.MANAGE_COACHUP, loginUser?.userPermission)
            ? ["Close", "Ready For Review"]
            : ["Close"],
      });
      if (res?.success) {
        setReportsList(res.data?.allReports?.CoachupReports || []);
        let reportQuestions = [];
        let newPreviousQuestions = [];
        if (res.data?.reportDetails) {
          if (res.data?.lastSubmittedReport) {
            newPreviousQuestions = res.data?.reportDetails?.CoachupReportQuestions?.map(
              (question) => ({
                id: question?.id,
                type: question?.answerType,
                question: question?.question,
                answer: prefillAnswers(question, res.data?.lastSubmittedReport),
                comments: question?.CoachupAnswerComments,
                childQuestionId: question?.childQuestion?.id,
                childQuestion: question?.childQuestion?.question,
                childQuestionAnswer: prefillAnswers(
                  question?.childQuestion,
                  res.data?.lastSubmittedReport,
                  true
                ),
              })
            );
            setPreviousQuestions(newPreviousQuestions);
          }
          if (res.data?.reportDetails.statusId === "Open" && showPreviousAnswers) {
            reportQuestions = previousQuestions;
          } else {
            reportQuestions = res.data?.reportDetails?.CoachupReportQuestions?.map((question) => ({
              id: question?.id,
              type: question?.answerType,
              question: question?.question,
              answer:
                question.answerType === "text"
                  ? question.CoachupUserAnswer?.answerText
                  : question.answerType === "true/false"
                  ? question.CoachupUserAnswer?.answerBool
                  : question.CoachupUserAnswer?.answerValue,
              comments: question?.CoachupAnswerComments,
              childQuestionId: question?.childQuestion?.id,
              childQuestion: question?.childQuestion?.question,
              childQuestionAnswer: question?.childQuestion?.CoachupUserAnswer?.answerValue,
            }));
          }
        }
        const labels = [];
        const graphdata = [];
        if (res?.data?.selfAssessmentScoreHistory) {
          res?.data?.selfAssessmentScoreHistory?.forEach(({ CoachupReportQuestions }) => {
            CoachupReportQuestions?.forEach((rqs) => {
              labels?.push(
                displayDate(moment.tz(rqs?.CoachupUserAnswer?.createdAt, loginUser.timezone))
              );
              graphdata?.push(rqs?.CoachupUserAnswer?.answerValue);
            });
          });
        }
        const xDataset = graphData?.datasets;
        xDataset[0].data = graphdata;
        setGraphData({
          labels,
          datasets: xDataset,
          average: res?.data?.avgerageSelfAssessmentScore,
        });
        setQuestions(reportQuestions);
        setPreviousQuestions(
          res.data?.lastSubmittedReport ? newPreviousQuestions : reportQuestions
        );
        setUser({
          id: res.data?.allReports?.id,
          name: res.data?.allReports?.name,
          profilePicture: res.data?.allReports?.profilePicture,
          role: res.data.allReports?.UserRole?.role,
          location: res.data.allReports?.Team?.TeamLocation?.location,
        });
        setSelectedReport(res?.data?.reportDetails);
        setSelectedReportId(res?.data?.reportDetails?.id);
      } else if (response?.status !== 403) {
        enqueueSnackbar(
          JSON.stringify({
            icon: "error",
            title: "Error",
            text: response?.data?.message || "Something went wrong",
          }),
          {
            variant: "custom",
          }
        );

        if (response?.status === 404) {
          navigate("/coach/reports");
        }
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      enqueueSnackbar(
        JSON.stringify({
          icon: "error",
          title: "Error",
          text: error?.response?.data?.message || error.message || "Something went wrong",
        }),
        {
          variant: "custom",
        }
      );
    }
  };

  const handleReportChange = (report) => {
    // setSelectedReport(report);
    setSelectedReportId(report.id);
    // getReportsData(user?.id, report?.id);
    // if (!reviewPage) {
    //   navigate(`/coach/reports/${report.id}`);
    // }
    if (!reviewPage) {
      navigate(`/coach/reports/view?reportId=${report.id}&userId=${user.id}`);
    } else {
      getReportsData(report?.id);
    }
  };

  const handleUserChange = (_, newUser) => {
    setSelectedUserId(newUser.id);
    navigate(`/coach/reports/user/${newUser.id}`);
  };

  const handleReportSubmit = async (data, shouldDraftReport = false) => {
    const payload = [];

    Object.keys(data).forEach((key) => {
      const questionId = parseInt(key?.split("-")?.[1], 10);
      const foundQuestion = questions?.find((question) => question?.id === questionId);

      if (foundQuestion?.type !== "pipeline health") {
        payload.push({
          questionId,
          answer: data?.[key],
          type: foundQuestion?.type,
          comment: data?.[key]?.comment,
        });
      } else {
        payload.push({
          questionId,
          answer: data?.[key]?.[`0-${questionId}`],
          type: foundQuestion?.type,
          comment: data?.[key]?.comment,
        });
        payload.push({
          questionId: foundQuestion?.childQuestionId,
          answer: data?.[key]?.[`1-${foundQuestion?.childQuestionId}`],
          type: foundQuestion?.type,
        });
      }
    });

    const newParams = new URLSearchParams(window.location.search);
    const urlData = {
      userId: newParams?.get("userId") || [],
      reportId: newParams?.get("reportId") || [],
    };
    try {
      const response =
        shouldDraftReport && isBoolean(shouldDraftReport)
          ? await draftReport({
              reportId: selectedReport?.id,
              userId: user.id,
              answers: payload,
            })
          : await submitReport({
              reportId: selectedReport?.id,
              userId: user.id,
              answers: payload,
            });
      if (response?.data?.success) {
        enqueueSnackbar(
          JSON.stringify({
            icon: "success",
            title: "Success",
            text: response?.data?.message || "Something Went Wrong",
          }),
          {
            variant: "custom",
          }
        );
        getReportsData(urlData.userId, urlData.reportId);
      } else if (response?.response?.status !== 403) {
        enqueueSnackbar(
          JSON.stringify({
            icon: "error",
            title: "Error",
            text: response?.response?.data?.message || "Something Went Wrong",
          }),
          {
            variant: "custom",
          }
        );
      }
    } catch (error) {
      enqueueSnackbar(
        JSON.stringify({
          icon: "error",
          title: "Error",
          text: error.message || "Something Went Wrong",
        }),
        {
          variant: "custom",
        }
      );
    }
  };

  const handleReportAccept = async (data) => {
    const { reportComment } = data;
    delete data.reportComment;
    const payload = [];
    Object.keys(data).forEach((comment) =>
      payload.push({
        questionId: parseInt(comment.slice(comment.indexOf("_") + 1), 10),
        comment: data[comment],
      })
    );
    const newParams = new URLSearchParams(window.location.search);
    const urlData = {
      userId: newParams?.get("userId") || [],
      reportId: newParams?.get("reportId") || [],
    };
    try {
      const response = await acceptReport({
        reportId: selectedReport?.id,
        userId: id || urlData.userId, // two different url can happend, need to account for both params (user/:id) & query (?userId=1)
        answers: payload,
        reportComment,
      });
      if (response?.data?.success) {
        enqueueSnackbar(
          JSON.stringify({
            icon: "success",
            title: "Success",
            text: response?.data?.message || "Something Went Wrong",
          }),
          {
            variant: "custom",
          }
        );
        getReportsData(urlData.userId, urlData.reportId);
      } else if (response?.response?.status !== 403) {
        enqueueSnackbar(
          JSON.stringify({
            icon: "error",
            title: "Error",
            text: response?.response?.data?.message || "Something Went Wrong",
          }),
          {
            variant: "custom",
          }
        );
      }
    } catch (error) {
      enqueueSnackbar(
        JSON.stringify({
          icon: "error",
          title: "Error",
          text: error.message || "Something Went Wrong",
        }),
        {
          variant: "custom",
        }
      );
    }
  };

  const getUserReportsTo = async () => {
    try {
      setUsersLoading(true);
      const response = await fetchUserReportsTo();
      if (response?.data?.success) {
        setUsers(response.data.data);
      } else if (response?.response?.status !== 403) {
        enqueueSnackbar(
          JSON.stringify({
            icon: "error",
            title: "Error",
            text: response?.response?.data?.message || "Something Went Wrong",
          }),
          {
            variant: "custom",
          }
        );
      }
      setUsersLoading(false);
    } catch (error) {
      setUsersLoading(false);
      enqueueSnackbar(
        JSON.stringify({
          icon: "error",
          title: "Error",
          text: error?.response?.data?.message || error.message || "Something Went Wrong",
        }),
        {
          variant: "custom",
        }
      );
    }
  };

  useEffect(() => {
    getReportsData();
    if (reviewPage) {
      setSelectedUserId(parseInt(id, 10));
    }
  }, [window.location.search, window.location.pathname]);

  useEffect(() => {
    if (reviewPage) {
      getUserReportsTo();
    }
  }, []);

  useEffect(() => {
    const tempNewPerviousQuestions = questions;
    setQuestions(previousQuestions);
    setPreviousQuestions(tempNewPerviousQuestions);
  }, [showPreviousAnswers]);

  const updateQuestionComment = (comment, questionId) => {
    setQuestions((prevQuestions) => {
      const oldQuestions = [...prevQuestions];
      const foundQuestion = oldQuestions.find((question) => question.id === questionId);
      if (foundQuestion) {
        foundQuestion.comments.push(comment);
      }
      return oldQuestions;
    });
  };

  const updateReportComment = (comment) => {
    setSelectedReport((prevReport) => {
      const oldReport = { ...prevReport };
      oldReport?.CoachupReportComments?.push(comment);
      return oldReport;
    });
  };

  return (
    <DashboardLayout>
      {/* header */}
      <DashboardNavbar />
      <MDBox py={2} sx={{ position: "relative" }}>
        <Loader loading={isLoading} />
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={4}>
            <Stack mb={1.5} spacing={3}>
              <UserCard user={user} />
              {reviewPage && users?.length > 0 && (
                <Autocomplete
                  options={users}
                  value={users.find((reportingUser) => reportingUser.id === selectedUserId) || null}
                  getOptionLabel={(option) => option.name || ""}
                  onChange={handleUserChange}
                  disableClearable
                  renderInput={(params) => (
                    <MDInput
                      {...params}
                      label="User"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {usersLoading ? <CircularProgress color="inherit" size={20} /> : null}
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                />
              )}
            </Stack>
          </Grid>
          <Grid item xs={12} sm={12} md={8}>
            {questions?.find((question) => question.type === "assessment") && (
              <SelfAssessmentGraph graphData={graphData} />
            )}
          </Grid>
          <Grid item xs={12} sm={12} md={8} mt={1}>
            {selectedReport?.userId === loginUser?.id &&
              (selectedReport?.statusId === "Open" ||
                selectedReport?.statusId === "Ready For Review" ||
                selectedReport?.statusId === "Draft") && (
                <DynamicForm
                  questions={questions}
                  report={selectedReport}
                  handleReportSubmit={handleReportSubmit}
                  updateQuestionComment={updateQuestionComment}
                  updateReportComment={updateReportComment}
                  showPreviousAnswers={showPreviousAnswers}
                  setShowPreviousAnswers={setShowPreviousAnswers}
                />
              )}

            {checkPermission(PERMISSIONS_NAME?.MANAGE_COACHUP, loginUser?.userPermission) &&
              selectedReport?.userId !== loginUser?.id &&
              selectedReport?.statusId === "Ready For Review" && (
                <ReviewReport
                  questions={questions}
                  report={selectedReport}
                  handleReportAccept={handleReportAccept}
                  updateQuestionComment={updateQuestionComment}
                  updateReportComment={updateReportComment}
                />
              )}

            {selectedReport?.statusId === "Close" && (
              <ReviewReport
                questions={questions}
                report={selectedReport}
                handleReportAccept={handleReportAccept}
              />
            )}
          </Grid>
          <Grid item xs={12} sm={12} md={4} mt={1}>
            <ReportsListing
              reports={reportsList}
              selectedReport={selectedReport}
              setSelectedReport={handleReportChange}
              selectedReportId={selectedReportId}
              setSelectedReportId={selectedReportId}
            />
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default ViewReport;
